import { DataImportStatusResponse } from './data-contracts';
import { HttpClient, RequestParams, TraceDataType } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class IndexHandler<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
	}

	/**
 * No description
 *
 * @tags IndexHandler
 * @name IndexDataImportBuildCreate
 * @request POST:/admin/index/dataImport/build
 * @secure
 * @response `200` `{
    jobStatusId?: string,

}` The requested completed successfully.
 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
 * @response `401` `void` Not authenticated. The user session is not valid.
 * @response `403` `void` The user is not authorized to perform the specified request.
 * @response `404` `void` The specified resource could not be found.
 * @response `500` `void` Internal server error. For details, see the server log files.
 */
	indexDataImportBuildCreate = (
		query?: {
			masterCatalogId?: string;
			fullBuild?: string;
			indexType?: string;
			indexSubType?: string;
			localeName?: string;
			validateIndex?: boolean;
			runCategoryRules?: boolean;
			storeId?: string;
			catentryId?: string;
			contractId?: string;
			currency?: string;
			numWorkers?: string;
			flushSize?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['indexDataImportBuildCreate'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/admin/index/dataImport/build`,
				params: _params,
				query: query,
				methodName: 'indexDataImportBuildCreate',
			};
			logger.trace(traceData);
		}
		return this.http.request<
			{
				jobStatusId?: string;
			},
			void
		>({
			path: `/admin/index/dataImport/build`,
			method: 'POST',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
	/**
	 * No description
	 *
	 * @tags IndexHandler
	 * @name IndexDataImportStatusList
	 * @request GET:/admin/index/dataImport/status
	 * @secure
	 * @response `200` `DataImportStatusResponse` The requested completed successfully.
	 * @response `400` `void` Bad request. The request could not be understood by the server due to malformed syntax.
	 * @response `401` `void` Not authenticated. The user session is not valid.
	 * @response `403` `void` The user is not authorized to perform the specified request.
	 * @response `404` `void` The specified resource could not be found.
	 * @response `500` `void` Internal server error. For details, see the server log files.
	 */
	indexDataImportStatusList = (
		query?: {
			jobStatusId?: string;
			detailInfo?: string;
			responseFormat?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId, skipErrorLogging, ..._params } = params as any;
		let traceData: TraceDataType | undefined;

		if (
			loggerCan('trace') &&
			(!this.http.traceDetails || this.http.traceDetails['indexDataImportStatusList'])
		) {
			traceData = {
				requestId,
				msg: 'API request',
				url: `${this.http.baseUrl}/admin/index/dataImport/status`,
				params: _params,
				query: query,
				methodName: 'indexDataImportStatusList',
			};
			logger.trace(traceData);
		}
		return this.http.request<DataImportStatusResponse, void>({
			path: `/admin/index/dataImport/status`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			traceData,
			skipErrorLogging,
			..._params,
		});
	};
}
